"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResults = getResults;
exports.questions = void 0;

var _sum2 = _interopRequireDefault(require("lodash/sum"));

var _utils = require("./utils");

var _rate = _interopRequireDefault(require("../options/rate.json"));

var _able = _interopRequireDefault(require("../options/able.json"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var likertScale = ["At no time", "Some of the time", "Less than half of the time", "More than half of the time", "Most of the time", "All of the time"];
var batteryId = _utils.screeners.RTW_US_ONBOARDING;
var baseProps = {
  batteryId: batteryId,
  aggregated: true,
  type: "multi",
  extraText: "",
  options: likertScale
};
var rtwUsOnboardingQuestions = [{
  prompt: "Assume that your work ability at its best has a value of 10 points. How many points would you give your current work ability? (0 means that you cannot currently work at all)",
  type: "slider",
  options: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"]
}, {
  prompt: "How do you rate your current work ability with respect to the physical demands of your work? ",
  options: _rate["default"],
  type: "dot"
}, {
  prompt: "How do you rate your current work ability with respect to the mental demands of your work? ",
  options: _rate["default"],
  type: "dot"
}, {
  prompt: "Do you believe that – from the standpoint of your health – you will be able to do your current job two years from now? ",
  options: _able["default"],
  type: "multi"
}, {
  prompt: "I do not think that I will be back to my normal work within 3 months. (Pick 0 if you are certain that you won't be back, pick 6 if you are confident of returning to work in 3 months)",
  type: "slider",
  options: ["0", "1", "2", "3", "4", "5", "6"]
}, {
  prompt: "I do not think that I will ever be able to go back to that work. (Pick 0 if you are certain that you won't ever be back to that work, pick 6 if you are confident of returning to it)",
  type: "slider",
  options: ["0", "1", "2", "3", "4", "5", "6"]
}, {
  prompt: "When was the last day that you were at work (on either full or partial duties)?",
  isTodayMaxDate: true,
  type: "date"
}];
var questions = (0, _utils.wrapBattery)(rtwUsOnboardingQuestions, baseProps);
exports.questions = questions;

function getResults(answers) {
  var score = Math.round((0, _sum2["default"])(answers));
  return {
    // RTW_US_ONBOARDING: score,
    RTW_US_ONBOARDING_1: answers[0],
    RTW_US_ONBOARDING_2: answers[1],
    RTW_US_ONBOARDING_3: answers[2],
    RTW_US_ONBOARDING_4: answers[3],
    RTW_US_ONBOARDING_5: answers[4],
    RTW_US_ONBOARDING_6: answers[5],
    RTW_US_ONBOARDING_7: answers[6]
  };
}